import { Select } from 'antd';
import styled, { css } from 'styled-components';
import { ChevronIcon } from '@/icons';
import { COLORS, pickThemeFontSize, pickThemeFontStyles } from '@/theme';

export const StyledWrapper = styled.div`
  position: relative;
  width: 100%;

  & .ant-select-selection-overflow-item-rest {
    pointer-events: none;
  }

  & .ant-select-selection-overflow-item-suffix {
    padding: 0 1rem !important;
  }
`;

export const StyledPrefix = styled.span`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: ${pickThemeFontSize('20')};
  color: ${COLORS.DARKEST_GRAY};
  margin: 0;
  padding: 0 0.625rem 0 1rem;
  z-index: 1;
`;

const arrowStyles = css`
  .ant-select-arrow .anticon:not(.ant-select-suffix) {
    pointer-events: none;
  }

  &.ant-select-open .ant-select-arrow {
    transform: rotate(-180deg) translateY(50%);
  }

  &.ant-select-multiple.ant-select-allow-clear.ant-select-open .ant-select-arrow {
    transform: rotate(-180deg) translate(25%, 50%);
  }

  .ant-select-arrow {
    transition: transform 0.24s;
    color: ${COLORS.DARKEST_GRAY};
    width: 1.5rem;
    height: 1.5rem;
    margin: 0;
    top: 50%;
    transform: translateY(-50%);
    justify-content: center;
  }

  &.ant-select-multiple.ant-select-allow-clear .ant-select-arrow {
    transform: translate(-25%, -50%);
  }

  .ant-select-clear {
    width: 1.5rem;
    height: 1.5rem;
    font-size: ${pickThemeFontSize('16')};
    margin-top: -0.5rem;
    background: ${COLORS.LIGHTEST_GRAY};
  }
`;

const selectStyles = css`
  ${StyledPrefix} + &.ant-select {
    &-single:not(&-customize-input) .ant-select-selector,
    &-multiple:not(&-customize-input) .ant-select-selector {
      padding-left: 2.875rem;
    }

    &-multiple .ant-select-selection-placeholder,
    &-single .ant-select-selector .ant-select-selection-search {
      left: 2.875rem;
    }
  }
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  ${arrowStyles};
  ${selectStyles};
` as typeof Select;

export const StyledDownWrapper = styled.div`
  & .ant-select-item {
    ${pickThemeFontStyles('12', '20')};

    padding: 0 0.5rem;

    &-option {
      & .ant-select-item-option-content,
      & .ant-select-item-option-state {
        padding: 0.5rem 0;
      }
    }
  }
`;

export const StyledDownIcon = styled(ChevronIcon)`
  font-size: ${pickThemeFontSize('24')};
`;

export const StyledTag = styled.div<{
  $isHighlighted?: boolean;
}>`
  ${pickThemeFontStyles('14', '16', 'SEMI_BOLD')};
  text-align: start;
  border: 1px solid ${COLORS.DARK_GRAY};
  background: ${COLORS.WHITE};
  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;
  height: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  & button {
    display: flex;
  }

  svg {
    width: 1rem;

    path {
      fill: ${COLORS.DARK_GRAY};
    }
  }
`;
